import React, { type ReactNode } from "react";

import { twJoin } from "tailwind-merge";
import dictionary from "@/../config/dictionary.config";

const styles = {
  neutral: "border-neutral-900 bg-neutral-50",
  positive: "border-success-500 bg-success-50",
  negative: "border-error-500 bg-error-50",
} as const;

const labelColor = {
  neutral: "text-neutral-900",
  positive: "text-success-800",
  negative: "text-error-800",
} as const;

const valueColor = {
  neutral: "text-neutral-900",
  positive: "text-success-950",
  negative: "text-error-950",
} as const;

interface UiDetailsSingleStatProps {
  label: string;
  value?: number;
  placeholder?: string;
  formatter?: (value: number) => ReactNode;
  color?: "neutral" | "positive" | "negative";
  forceFormatter?: boolean;
}

export default function UiDetailsSingleStat({
  label,
  value,
  formatter = value => `${value}`,
  color = "neutral",
  placeholder = "N/A",
  forceFormatter = false,
}: UiDetailsSingleStatProps) {
  const clearedValue = value !== dictionary.statsDefaultValue ? value : undefined;

  return (
    <div className={twJoin("min-w-[175px] flex-grow rounded-l-full rounded-br-full border-0.5 px-6 py-4 text-right", styles[color])}>
      <h4 className={twJoin("font-mono text-xs uppercase leading-4", labelColor[color])}>{label}</h4>
      <div className={twJoin("font-mono text-3xl font-bold leading-9", valueColor[color])}>
        {typeof clearedValue !== "undefined" || forceFormatter ? formatter(clearedValue ?? -1000000) : placeholder}
      </div>
    </div>
  );
}
